import { styled } from '@mui/material/styles';

import { styleConfigs } from '../resources/styleConfigs';
import BoxWrapper from '../wrappers/BoxWrapper';

export const BoxStyled = styled(BoxWrapper)(() => ({
  position: 'relative',
  width: styleConfigs.dimensions.percent100,
  height: styleConfigs.dimensions.percent100,
}));
